import { render, staticRenderFns } from "./AppIconSafety.vue?vue&type=template&id=0b220054&scoped=true&"
import script from "./AppIconSafety.vue?vue&type=script&lang=js&"
export * from "./AppIconSafety.vue?vue&type=script&lang=js&"
import style0 from "./AppIconSafety.vue?vue&type=style&index=0&id=0b220054&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b220054",
  null
  
)

export default component.exports